class Status {
    static standBy = -1;
    static onGoing = 0;
    static failed = 1;
    static completed = 2;
    static notAuthroized = 3;
}

export class DeletionStatus extends Status {
}

export class RecoveryStatus extends Status {
}

export class UpgradeStatus extends Status {
}

export class CreateStatus extends Status {
}

export class UpdateStatus extends Status {
}

export class BackupStatus extends Status {
}

export class ConnectionStatus extends Status {
}